import React, { useState } from "react";
import { IMessage, IAnswerRequest } from "app/api/types";
import EditMessageForm from "app/components/EditMessageForm";

import "./styles.scss";
import moment from "moment";

interface IProps {
  message: IMessage;
  onSubmit: (data: IAnswerRequest) => void;
  onDelete: (id: number) => void;
}

const Message: React.FC<IProps> = props => {
  const [isCollapsed, setCollapse] = useState(true);
  const [isDeleting, setDelete] = useState(false);

  const triggerCollapse = () => {
    setCollapse(!isCollapsed);
  };

  const onDelete = () => {
    setDelete(true);
    props.onDelete(props.message.id);
  };

  const styles = {
    minHeight: !isCollapsed ? "280px" : "60px",
    background: props.message.answer ? "rgb(239, 255, 239)" : ""
  };

  return (
    <>
      <div className="time">
        {moment(props.message.date).format("YYYY-MM-DD HH:MM:SS")}
      </div>
      <div
        className={`phrase-container ${isDeleting ? "deleting" : ""}`}
        style={styles}
      >
        <div className="phrase-wrapper">
          <div className="left-block" onClick={triggerCollapse}>
            <div className="phrase-text">{props.message.name}</div>
            <div className="phrase-translation">
              {props.message.message.slice(0, 20) + "..."}
            </div>
          </div>

          <div className="right-block">
            <p className="phrase-del" onClick={onDelete}>
              удалить
            </p>
          </div>
        </div>

        <EditMessageForm
          message={props.message}
          onSubmit={props.onSubmit}
          isActive={!isCollapsed}
        />
      </div>
    </>
  );
};

export default Message;
